import { Icon } from '@components/primitives/Icon'
import { Text } from '@components/primitives/Text'
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons/faSpinnerThird'
import { useState } from 'react'

export function ShareTrialViaButton({
  children,
  label,
  onClick,
}: {
  children?: React.ReactNode
  label: string
  onClick?: () => void
}) {
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = () => {
    setIsLoading(true)
    onClick?.()
    setTimeout(() => setIsLoading(false), 1000)
  }

  return (
    <div
      className='flex h-16 w-full flex-row items-center justify-start gap-x-3 rounded-md border border-neutral200 bg-neutral50 px-4 hover:cursor-pointer'
      onClick={handleClick}
    >
      {isLoading ? (
        <Icon
          className='w-6 animate-spin overflow-hidden text-neutral600'
          icon={faSpinnerThird}
          size='lg'
        />
      ) : (
        <div className='w-6 overflow-hidden pt-2'>{children}</div>
      )}
      <Text
        className='text-neutral900'
        element='p'
        styleName='p'
        value={label}
      />
    </div>
  )
}
